import { object, string } from "yup";
import { FormValues } from "../types/FormValues";
import { UserStamps } from "../types/UserStamps";
import { Shape } from "../types/yup";
import { Account } from "./Account";
import { CustomerContact } from "./CustomerContact";
import { Transaction } from "./Transaction";
import { numberSchema } from "./common";

export interface Customer extends UserStamps {
  id: number;
  name: string;
  phone: string;
  notes: string;
  id_number: string;
  account_id: Account["id"];
  readonly contacts_count: number;
  readonly contacts: Array<CustomerContact>;
  readonly balance: number;
  readonly account: Account;
  readonly transactions: Array<Transaction>;
}

export const CustomerSchema = object<Shape<FormValues<Customer>>>().shape({
  id: numberSchema,
  name: string().required(),
  id_number: string()
    .matches(/^(\d{4,12}|)$/, "Should be only numbers with 4 to 12 characters")
    .when("id", {
      is: (id: string) => !id,
      then: string().required(),
    }),
  phone: string(),
  notes: string(),
  account_id: numberSchema.required(),
});

export const CustomerCast = (data: unknown) =>
  CustomerSchema.cast(data, { stripUnknown: true }) as Customer;

export const isCustomer = (data: unknown): data is Customer =>
  CustomerSchema.isValidSync(data);
